import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import './ThankYouPopup.css';

const ThankYouPopup = ({ show, onHide, title, message, buttonText = "Close" }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            className="thank-you-modal"
        >
            <Modal.Body className="thank-you-modal-body">
                <div className="thank-you-icon-container">
                    <FaCheckCircle className="thank-you-icon" />
                </div>
                <h2 className="thank-you-title">{title}</h2>
                <p className="thank-you-message">{message}</p>
                <Button 
                    variant="primary" 
                    onClick={onHide}
                    className="thank-you-button"
                >
                    {buttonText}
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default ThankYouPopup;

